import SearchField from '../../../@types/SearchField';
import { VendorServerWhereInput } from '../../../__generated__/graphql';

const VENDOR_SERVERS_TABLE_SEARCH_FIELDS: SearchField<VendorServerWhereInput>[] = [];

export default VENDOR_SERVERS_TABLE_SEARCH_FIELDS;
